import React from 'react'

const SectionTitleComponent = () => {
  return (
    <div className='hivalueplussectiontitle mb32'>
    <div className='container'>
        <div className='d-flex align-items-center '>
            <div className='text-capitalize me-2'>
                <h4 className='d-inline-block m-0 fw-semibold f36 '>
                    <span className='txtgray'>Honda Refurbished Products</span> <span className='texthivalueplus'>Category</span>
                </h4>
            </div>
            <div className='flex-grow-1 position-relative bg-border-mid'></div>
        </div>
    </div>
    </div>
  )
}

export default React.memo(SectionTitleComponent)
